import { ThemeProvider } from '@mui/material';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { LogsMode, LogsModeProvider } from '@/features/logsMode';
import { App } from '@/pages/App';
import { CalendarPage } from '@/pages/CalendarPage';
import { InDevPage } from '@/pages/InDevPage';
import { IntegrationsPage } from '@/pages/IntegrationsPage';
import { LegacyLoginPage, LoginPage } from '@/pages/LoginPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { PrivateOutlet } from '@/pages/PrivateOutlet';
import { StopwatchesPage } from '@/pages/StopwatchesPage';
import { TimesheetsPage } from '@/pages/TimesheetsPage';
import { YandexOutlet } from '@/pages/YandexOutlet';
import { appTheme } from '@/styles/theme';
import {
  BoardBacklogPage,
  BoardColumnsPage,
  BoardPage,
  BoardsPage,
  CreateIssuePage,
  MyIssuesPage,
  QueuePage,
  QueuesPage,
  TrackerLayout,
  trackerUrls,
} from '@/tracker';

import Layout from '../../components/Layout';

import { routerUrls } from './routerUrls';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: '/',
        element: <PrivateOutlet />,
        children: [
          {
            // Старый учёт — только с токеном Яндекс Трекера
            element: <YandexOutlet />,
            children: [
              {
                path: routerUrls.root,
                element: (
                  <Layout>
                    <TimesheetsPage />
                  </Layout>
                ),
              },
              {
                path: routerUrls.calendar,
                element: (
                  <Layout>
                    <CalendarPage />
                  </Layout>
                ),
              },
            ],
          },
          {
            path: routerUrls.v2.table,
            // Провайдер снаружи Layout: шапка тоже знает режим и показывает «v2»
            element: (
              <LogsModeProvider value={LogsMode.v2}>
                <Layout>
                  <ThemeProvider theme={appTheme}>
                    <TimesheetsPage />
                  </ThemeProvider>
                </Layout>
              </LogsModeProvider>
            ),
          },
          {
            path: routerUrls.v2.calendar,
            element: (
              <LogsModeProvider value={LogsMode.v2}>
                <Layout>
                  <ThemeProvider theme={appTheme}>
                    <CalendarPage />
                  </ThemeProvider>
                </Layout>
              </LogsModeProvider>
            ),
          },
          {
            path: routerUrls.settings,
            element: (
              <Layout>
                <IntegrationsPage />
              </Layout>
            ),
          },
          {
            path: routerUrls.stopwatches,
            element: (
              <Layout>
                <StopwatchesPage />
              </Layout>
            ),
          },
          {
            path: trackerUrls.root,
            element: (
              <Layout>
                <TrackerLayout />
              </Layout>
            ),
            children: [
              { index: true, element: <MyIssuesPage /> },
              { path: trackerUrls.queues, element: <QueuesPage /> },
              { path: trackerUrls.queue(':queueKey'), element: <QueuePage /> },
              { path: trackerUrls.newIssue, element: <CreateIssuePage /> },
              { path: trackerUrls.boards, element: <BoardsPage /> },
              {
                path: trackerUrls.board(':boardId'),
                element: <BoardPage />,
                // Вкладки под общей шапкой доски: при переключении она не перерисовывается
                children: [
                  { index: true, element: <BoardColumnsPage /> },
                  { path: trackerUrls.boardBacklog(':boardId'), element: <BoardBacklogPage /> },
                ],
              },
              { path: '*', element: <InDevPage /> },
            ],
          },
        ],
      },
      {
        path: routerUrls.login,
        element: <LegacyLoginPage />,
      },
      {
        path: routerUrls.loginKtsid,
        element: <LoginPage />,
      },
      {
        // Ошибка входа через KTSID: бэк отдаёт её редиректом на /error
        path: '/error',
        element: <Navigate to={`${routerUrls.loginKtsid}?error=auth_failed`} replace />,
      },
      {
        path: '*',
        element: <NotFoundPage />,
      },
    ],
  },
]);
